export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["从"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["到"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["转账"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["在自己的账户之间转账"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["钱包内转账"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发送方和接收方账户必须不同"])}
}